import React from 'react';
import { Redirect } from 'react-router-dom'

export default class EditList extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            redirect: false,
            list: {
                name:"",
                listID: props.id,
                linkedList: {listItems:[]},
                linkedListID: -1,
                listItems: []
            },
            lists: [{name:"None", listID:-1}]
        }
    }
    componentDidMount()
    {
        if(this.props.id > 0){
            this.loadList();
        }
        this.loadLists();
    }
    loadList()
    {
        this.props.api.send({
            controller: "List",
            action: "GetList",
            method: "post",
            body: JSON.stringify({listID: this.props.id}),
            success: (response) => {
                if(response.success){
                    if(response.lists[0].linkedList !== null){
                        response.lists[0].linkedList.listItems.unshift({name: "None", itemID: -1});
                    }
                    this.setState({loaded: true, list: response.lists[0]}) 
                }else{
                    this.setState({loaded: true, error: true})
                }
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    loadLists(){
        this.props.api.send({
            controller: "List",
            action: "GetMyLists",
            method: "get",
            success: (response) => {
                if(response.success){
                    response.lists.unshift({name: "None", listID: -1});
                    this.setState({loaded: true, lists: response.lists}) 
                }else{
                    this.setState({loaded: true, error: true})
                }
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    getLinkedList(list){
        let linkedListID = list.linkedListID
        this.props.api.send({
            controller: "List",
            action: "GetList",
            method: "post",
            body: JSON.stringify({listID: linkedListID}),
            success: (response) => {
                if(response.success)
                {
                    response.lists[0].listItems.unshift({name: "None", itemID: -1});
                    list.linkedList = response.lists[0];
                    this.setState({loaded: true, list: list}) 

                }else{
                    this.setState({loaded: true, error: true})
                }
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    addListItem(e){
        var list = this.state.list;
        var items = list.listItems;
        items.push({itemID: null, listID: list.listID, linkedItemID: null, linkedItem: null, isEditing: false, name: ""})
        this.setState({list: list});
    }
    startEditingItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        items[liidx]["edit_name"] = items[liidx].name
        items[liidx]["edit_linkedItemID"] = items[liidx].linkedItemID
        items[liidx]["edit_linkedItem"] = items[liidx].linkedItem
        items[liidx].isEditing = true;
        this.setState({list: list});
    }
    cancelEditingItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        if(items[liidx].isEditing){
            items[liidx].name = items[liidx]["edit_name"]
            items[liidx].linkedItemID = items[liidx]["edit_linkedItemID"] 
            items[liidx].linkedItem = items[liidx]["edit_linkedItem"] 
            items[liidx].isEditing = false;
            this.setState({list: list});
        }
    }
    confirmEditingItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        items[liidx].isEditing = false;
        this.setState({list: list});
    }
    removeEditingItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        items.splice(liidx, 1);
        this.setState({list: list});
    }
    editList(e){
        var list = this.state.list;
        if(e.target.name === "linkedListID"){ //reset
            list.listItems.map((item, index) => this.cancelEditingItem(null, index))
            list[e.target.name] = Number(e.target.value);
        }else{
            
        list[e.target.name] = e.target.value;
        }
        this.setState({list: list});

        if(e.target.name === "linkedListID")
            this.getLinkedList(list);
    }
    editItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        items[liidx][e.target.name] = e.target.value;
        this.setState({list: list});
    }
    editLinkedItem(e, liidx){
        var list = this.state.list;
        var items = list.listItems;
        var linkedItems = list.linkedList.listItems;
        var linkedItemID = Number(e.target.value)
        if(linkedItemID > 0){
            items[liidx].linkedItemID = linkedItemID;
            var clone = JSON.parse(JSON.stringify(linkedItems))
            var filter = clone.filter(i => i.itemID === linkedItemID)
            if(filter.length === 1){
                items[liidx].linkedItem = filter[0];
            }
        }
        this.setState({list: list});
    }
    saveList(){
        let list = this.state.list;
        this.props.api.send({
            controller: "List",
            action: "SaveList",
            method: "post",
            body: JSON.stringify(list),
            success: (response) => {
                if(response.success){
                    if(response.lists[0].linkedList !== null){
                        response.lists[0].linkedList.listItems.unshift({name: "None", itemID: -1});
                    }
                    this.setState({loaded: true, redirect: true, list: response.lists[0]}) 
                }else{
                    this.setState({loaded: true, error: true})
                }
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    
    renderRedirect = () => {
        if (this.state.redirect) {
          return <Redirect to={'/Lists/edit/' + this.state.list.listID} />
        }
    }
    
    render()
    {
        const list = this.state.list;
        const listItems = this.state.list.listItems;
        const linkedList= this.state.list.linkedList;
        const linkedListItems = linkedList !== undefined && linkedList !== null ? linkedList.listItems : [];
        
        const linkedItemsList = linkedListItems.map(ll =>
            <option key={ll.itemID} value={ll.itemID}>{ll.name}</option>
        );
        const lists = this.state.list.listItems.map((l, liidx) => 
        
        <tr key={l.liidx}>
            {l.isEditing === false && (list.linkedList !== null && list.linkedListID !== -1) ? (
                <React.Fragment key={l.liidx}>
                    <td>{l.name}</td>
                    <td>{l.linkedItem !== null && l.linkedItem !== undefined ? l.linkedItem.name : ""}</td>
                    <td><button className="lmsbutton" onClick={(e) => this.startEditingItem(e, liidx)}>Edit</button></td>
                </React.Fragment>
            ) : l.isEditing === false && (list.linkedList === null || list.linkedListID === -1) ? (
                <React.Fragment key={l.liidx}>
                    <td>{l.name}</td>
                    <td><button className="lmsbutton" onClick={(e) => this.startEditingItem(e, liidx)}>Edit</button></td>
                </React.Fragment>
            ) : l.isEditing === true && (list.linkedList !== null && list.linkedListID !== -1) ? (
                <React.Fragment key={l.liidx}>
                    <td><input type="text" name="name" value={l.name} onChange={(e) => this.editItem(e, liidx)}></input></td>
                    <td>  
                        <div className="">
                            <label className="lsmformlabel" style={{width: "auto"}}>Linked Item:</label>
                            <select className="lmsforminput" name="linkedListID" style={{marginLeft: "10px", width: "200px"}} value={l.linkedItemID} onChange={(e) => this.editLinkedItem(e, liidx)} >
                            {linkedItemsList}    
                            </select> 
                        </div>
                    </td>
                    <td><button className="lmsbutton" onClick={(e) => this.confirmEditingItem(e, liidx)}>Confirm</button>
                    <button className="lmsbutton" onClick={(e) => this.cancelEditingItem(e, liidx)}>Cancel</button>
                    <button className="lmsbutton" onClick={(e) => this.removeEditingItem(e, liidx)}>Remove</button></td>
                </React.Fragment>
            ) : l.isEditing === true && (list.linkedList === null || list.linkedListID === -1) ? (
                <React.Fragment key={l.liidx}>
                    <td><input type="text" name="name" value={l.name} onChange={(e) => this.editItem(e, liidx)}></input></td>
                    <td><button className="lmsbutton" onClick={(e) => this.confirmEditingItem(e, liidx)}>Confirm</button>
                    <button className="lmsbutton" onClick={(e) => this.cancelEditingItem(e, liidx)}>Cancel</button>
                    <button className="lmsbutton" onClick={(e) => this.removeEditingItem(e, liidx)}>Remove</button></td>
                </React.Fragment>
            ) : null}
        </tr>
        )
        return (
            <div className="lmsdisplayarea" style={{marginTop: "10px"}}>
                <div className="lmsformitem lmsformitemheader">
                    <label className="lmsformlabel" style={{width: "auto"}}>Name:</label>   
                    <input type="text" name="name" className="lmsforminput" value={this.state.list.name} onChange={(e) => this.editList(e)}/>
                </div>
                <div className="lmsformitem lmsformitemheader">
                    <label className="lsmformlabel" style={{width: "auto"}}>Linked List:</label>
                    <select className="lmsforminput" name="linkedListID" style={{marginLeft: "10px", width: "140px"}} value={this.state.list.linkedListID} onChange={(e) => this.editList(e)}>
                        {this.state.lists.map(link =>
                            <option key={link.listID} value={link.listID}>{link.name}</option>
                        )}        
                    </select>
                </div>
                {this.state.loaded ?
                    listItems.length > 0 ? (
                        <div className="list-item-container">
                            <table className="lmstable">
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        {list.linkedList !== null && list.linkedListID !== -1? 
                                        <th>Name</th>
                                        : null}
                                        <th style={{width: "20%", whiteSpace: "nowrap"}}></th>
                                    </tr>
                                    {lists}
                                </tbody>
                            </table> 
                                               
                        </div>
                    ) : (
                    <p>
                        <i>You do not currently have any list items. Use the button below to create new list items.</i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
                <button className="lmsbutton" onClick={e => this.addListItem(e)}>Add List Item</button>
                <button className="lmsbutton" onClick={e => this.saveList()}>Save</button>
                {this.renderRedirect()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/lists/editlist.js